// extracted by mini-css-extract-plugin
export default {"pane":"Pane_pane__FyLiN","active":"Pane_active__sim5z"};